import { useEffect } from 'react';
import { showGemToast, type PlayerProfile } from '@goodtime/engine';
import gemUrl from '../assets/icon/gem.png';
import { BUTTON_PLATES } from '../themes/roadGames';

/**
 * A "+N" gem toast whenever the player's gem balance goes up, with a
 * bright pickup sound (producer brief 2026-06-04: "I have no idea when I'm
 * being awarded gems"). Top centre, under the wallet, where the eye can't
 * miss it; several can be up at once.
 *
 * <p>Drawn in Pixi on the overlay canvas over every screen (engine
 * `showGemToast`, on the kit's painted wooden plate; producer 2026-10-14:
 * everything in the game in Pixi). Mounted at the App root; renders
 * nothing itself.
 */
export interface GemDropToastProps {
  profile: PlayerProfile;
}

const ART = { gem: gemUrl, plates: BUTTON_PLATES };

export function GemDropToast({ profile }: GemDropToastProps) {
  useEffect(() => {
    const sub = profile.events.on('gems-changed', (event) => {
      const delta = event.after - event.before;
      // Spends and no-ops say nothing.
      if (delta > 0) void showGemToast(delta, ART);
    });
    return () => sub.dispose();
  }, [profile]);
  return null;
}
